'use client';
import React from 'react';
import { useSession } from 'next-auth/react';
import { cn } from '@core/helpers/misc/GeneralUtils';
import { Button } from '@/core/ui/primitives/button';
import { useFeedback } from './FeedbackProvider';
interface FeedbackFabProps {
  className?: string;
}
export function FeedbackFab({ className = '' }: FeedbackFabProps) {
  const { status } = useSession();
  const { open } = useFeedback();

  // Only show feedback button for authenticated users (spam protection)
  if (status !== 'authenticated') {
    return null;
  }

  return (
    <div className={cn('fixed bottom-4 right-4 z-50 select-none', className)} aria-live='polite'>
      <Button
        type='button'
        variant='outline'
        size='icon'
        onClick={open}
        className='!h-10 !w-10 !rounded-full border border-border bg-background/95 text-foreground shadow-md backdrop-blur transition hover:shadow-lg supports-[backdrop-filter]:bg-background/70'
        aria-label='Open feedback'>
        <svg className='h-4 w-4 -ml-0.5 text-foreground/80' aria-hidden='true' focusable='false'>
          <use href='/app-icons.svg#fas-paper-plane' />
        </svg>
      </Button>
    </div>
  );
}
export default FeedbackFab;
